// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICreateRealtyRequest,
  TCreateRealtyModel,
  IMappers,
  TCreateRealtyResponse,
  ICreateRealtyResponse,
  ICreateRealtyResponseError,
} from './types';

export const defaultConfig: TCreateRealtyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v2/create-realty/',
  requestType: 'json',
} as TCreateRealtyModel;

export function createCreateRealtyModel(parameters: ICreateRealtyRequest): TCreateRealtyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICreateRealtyRequest;
}

export async function fetchCreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateRealtyOptions<TResponse200, TResponse400>): Promise<TCreateRealtyResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createCreateRealtyModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateRealtyResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICreateRealtyResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateRealtyResponse;
}
